import { render, staticRenderFns } from "./nfs.vue?vue&type=template&id=13392d40&"
import script from "./nfs.vue?vue&type=script&lang=js&"
export * from "./nfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports